export const mcdProductList = ["Coca-Cola Unisex Denim Jacket"]
